import React from 'react'
function Footer() {
  return (
    <>
    {/* ===== CTA AREA STARTS ===== */}
     <div className="vl-footer1-section-area sp8">
      <div className="container">
        <div className="row">
          {/* Logo & Socials */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-logo1">
              <img src="/assets/img/chester_logo2.png" alt="Logo" />
              <div className="space16"></div>
              <p>
                We provide expert best services technology to meet your unique
                needs. Whether you’re looking.
              </p>
              <div className="space24"></div>
              <ul>
                <li>
                  <a href="#">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#" className="m-0">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <div className="space30 d-md-none d-block"></div>
            <div className="vl-footer-widget">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <a href="/aboutus">About Us</a>
                </li>
                <li>
                  <a href="/career">Career</a>
                </li>
                <li>
                  <a href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Services */}
          <div className="col-lg-3 col-md-6">
            <div className="vl-footer-widget">
              <div className="space30 d-lg-none d-block"></div>
              <h3>Our Services</h3>
              <ul>
                <li>
                  <a href="/mobile-app-development">Mobile App Development</a>
                </li>
                <li>
                  <a href="/web-development">Website Development</a>
                </li>
                <li>
                  <a href="/ui-ux-design">UI/UX</a>
                </li>
                <li>
                  <a href="/digital-marketing">Digital Marketing</a>
                </li>
                <li>
                  <a href="/internet-of-things">Internet Of Things - IOT </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-3 col-md-6">
            <div className="vl-footer-widget">
              <div className="space30 d-lg-none d-block"></div>
              <h3>Contact Us</h3>
              <ul>
                <li>
                  <a href="tel:07533139643">
                    <img src="/assets/img/icons/phn1.svg" alt="Phone" />
                    (+44)-7533139643
                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <img src="/assets/img/icons/location1.svg" alt="Location" />
                    421 Allen, Mexico 4233
                  </a>
                </li> */}
                <li>
                  <a href="mailto:info@chesteritsolutions.com">
                    <img src="/assets/img/icons/email1.svg" alt="Email" />
                    info@chesteritsolutions.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="space60"></div>
        <div className="row">
          <div className="col-lg-12">
            <div className="vl-copyright-area">
              <p><a href='https://chesteritsolutions.com/'>© Copyright 2025 - Chester IT Solutions All Right Reserved.</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Footer
